<template>
  <transition-group name="fade" tag="section" class="site-notifications">
    <article
      v-for="(notification, index) in notifications"
      :key="`site-notification-${index}`"
      class="site-notifications__message"
      :class="[`site-notifications__message--color-${notification.color}`]"
    >
      <p>
        {{ notification.message }}
      </p>
      <button
        v-if="notification.manualClose"
        class="site-notifications__close-button"
        @click="removeNotification(notification)"
      >
        Close
      </button>
    </article>
  </transition-group>
</template>

<script>
  export default {
    name: 'SiteNotifications',
    data: () => ({
      notifications: [],
    }),
    methods: {
      async addNotification(notification) {
        // TODO: ADD A STATE MANAGEMENT SYSTEM TO HANDLE THIS

        notification.id = Date.now();

        this.notifications.push(notification);

        await this.$nextTick();

        const manualClose = notification.manualClose ?? false;

        if (!manualClose) {
          setTimeout(() => {
            this.removeNotification(notification.id);
          }, 2000);
        }
      },
      removeNotification(newNotificationId) {
        this.notifications = this.notifications.filter(
          (notification) => notification.id !== newNotificationId
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  .site-notifications {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    padding: 1rem;
    gap: 1rem;

    position: fixed;
    bottom: 0;
    right: 0;
    max-height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;

    pointer-events: none;

    &__message {
      display: flex;
      padding: 1rem;
      border-radius: 5px;
      width: 300px;

      pointer-events: all;

      &--color-success {
        background-color: #09a684;
        color: #ffffff;
      }
      &--color-danger {
        background-color: #f44336;
        color: #ffffff;
      }
      &--color-warning {
        background-color: #ff9800;
        color: #ffffff;
      }
    }

    &__close-button {
      margin-left: auto;
      background-color: transparent;
      border: none;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
</style>
